module.exports = __webpack_public_path__ + "img/CUADRO_Esp-Tecnicas-PALM-X6.0eed4192.png";